
import Typography from "@mui/material/Typography";
import './columns.sass';

const cellRenderer = (props) => (
    <Typography variant="h3" data-testid={props.value} className={props.value === '-' ? "cellStyle" : null}>{props.value}</Typography>
);

const makeColumn = (Header, accessor) => (
    { Header, accessor, Cell: cellRenderer }
);

const commonColumns = [
    makeColumn('load_id', 'loadId'),
    makeColumn('carrier_id', 'carrierId'),
    makeColumn('service', 'serviceId'),
    makeColumn('origin_city', 'originCity'),
    makeColumn('origin_state', 'originState'),
];

export const COLUMN_ARRIVAL_AT_PICK_STOP_CER = [
    ...commonColumns,
    makeColumn('carrier_actual_pickup_data_time', 'actualArrivalTimestampCarrier'),
    makeColumn('event_reporting_date_time', 'tmsActualArrivalTimestampReportedAt'),
];

export const COLUMN_DEPARTURE_FROM_PICK_STOP_CER = [
    ...commonColumns,
    makeColumn('carrier_actual_depart_data_time', 'actualDepartureTimestampCarrier'),
    makeColumn('event_reporting_date_time', 'tmsActualDepartureTimestampReportedAt'),
];

export const COLUMN_ARRIVAL_AT_DROP_STOP_CER = [
    ...commonColumns,
    makeColumn('carrier_actual_delivery_data_time', 'actualArrivalTimestampCarrier'),
    makeColumn('event_reporting_date_time', 'tmsActualArrivalTimestampReportedAt'),
    makeColumn('drop_location', 'destinationLocation'),
];

export const COLUMN_DEPARTURE_FROM_DROP_STOP_CER = [
    ...commonColumns,
    makeColumn('carrier_actual_depart_data_time', 'actualDepartureTimestampCarrier'),
    makeColumn('event_reporting_date_time', 'tmsActualDepartureTimestampReportedAt'),
    makeColumn('drop_location', 'destinationLocation'),
];